import { HeaderMenu } from "components"
import { Fragment } from "react"
import { useSearchParams } from "react-router-dom"
import { ItemsAdjustment } from "./ItemAdjustment"
import { ItemsBuild } from "./ItemBuild"
import { ItemsCount } from "./ItemCount"
import { ItemsGroup } from "./ItemGroup"
import { ItemsReceived } from "./ItemReceived"
import { ItemsTransfer } from "./ItemTransfer"
import { TabNavRegister } from "./TabNavRegister"
import { TabRegisterPath } from "./types"

type TabsSearchParams = {
  tabs: TabRegisterPath
}

export default function InventoriRegister() {
  const [searchParams, setSearchParams] = useSearchParams({ tabs: "items-group" } as TabsSearchParams)
  const activeTab = searchParams.get("tabs")
  const setActiveTab = (path: string) => setSearchParams({ tabs: path })

  return (
    <Fragment>
      <section className="container my-5">
        <HeaderMenu title="INVENTORY REGISTER" />
        <TabNavRegister activeTab={activeTab!} setActiveTab={setActiveTab} />
        {activeTab === "items-group" && <ItemsGroup />}
        {activeTab === "items-transfer" && <ItemsTransfer />}
        {activeTab === "items-adjustment" && <ItemsAdjustment />}
        {activeTab === "items-count" && <ItemsCount />}
        {activeTab === "items-build" && <ItemsBuild />}
        {activeTab === "items-received" && <ItemsReceived />}
      </section>
    </Fragment>
  )
}
